import React from 'react'
import Image from 'next/image'

import { Row, Rows, Column } from '@/components/layout'
import arrowsIconImg from '@/assets/buy-flow/right-side/arrows-icon.png'
import trustReviewStar from '@/assets/buy-flow/right-side/trust-reviews-5star.png'

import styles from './CheckoutSidePassword.module.scss'

export default function CheckoutSidePassword() {
  return (
    <Column center className={styles.background} gap={32} size={66}>
      <Row className={styles.row}>
        <Column>
          <Rows className={styles.left} gap={32}>
            <Rows gap={12}>
              <Image alt="" className={styles.neatLogo} src={arrowsIconImg} />
              <h1>Trusted by<br />Everyday People<br /> Like You</h1>
            </Rows>
            <Rows gap={12}>
              <p>“It’s my personal secretary that goes to my filing cabinet and puts everything in order for me.”</p>
              <p className={styles.attribution}>Alice J.</p>
            </Rows>
          </Rows>
        </Column>
        <Column center>
          <a href="https://www.trustpilot.com/review/neat.com?utm_medium=trustbox&utm_source=Mini" rel="noreferrer" target="_blank">
            <Image alt="Trutpilot 5 star" src={trustReviewStar} />
          </a>
        </Column>
      </Row>
    </Column>
  )
}
